import { createContext, useContext } from 'react';

export type Locale = 'sv-SE' | 'nb-NO' | 'da-DK' | 'de-AT' | 'de-DE' | 'nl-NL' | 'en-GB';

// define base store names without environment suffix
export type Store = 'kgse' | 'kgno' | 'kgdk' | 'kgat' | 'kgde' | 'kgnl' | 'kggb';

// define supported languages and countries
export type Lang = 'SV' | 'NB' | 'DA' | 'DE' | 'DE' | 'NL' | 'EN';
export type Country = 'SE' | 'NO' | 'DK' | 'AT' | 'DE' | 'NL' | 'GB';

export interface Config {
	store: Store;
	sentryDsn?: string;
	sentryReplayEnabled?: boolean;
	version: string | undefined;
	baseUrl: string;
	domain: string;
	customerServiceEmail: string;
	customerServicePhoneNumber: string;
	locale: Locale;
	lang: Lang;
	country: Country;
	currencyCode: string;
	cmsContent: string;
	cmsImage: string;
	api: string;
	cms: string;
	archivedOrders: number;
	reCaptchaPubKey: string;
	alphabet: string;
	freeShippingLimit: number;
	defaultVat: number;
	currency: string;
	/**
	 * Whether the currency symbol comes before the amount.
	 *
	 * A property of the language, not of the currency: Dutch writes € 12,50 and German writes
	 * 12,50 €, and both are euro. Keyed off the currency it produced € 5,99 on ondio.de.
	 */
	currencyBeforeAmount: boolean;
	localCurrency: string;
	stripePubKey: string;
	googleAdsId: string;
	googleAdsConversion: string;
	googleSurveyId: string;
	googleMerchantId: number;
	analyticsId: string;
	ga4Id: string;
	snapEngageId: string;
	defaultCategory: number;
	bingAdsId: string;
	hotjarId: string;
	facebookPixelId: string;
	linkedinPixelId: string;
	criteoId: string;
	gtagId: string;
	plausibleTracking: boolean;
	loop54Api: string;
	ehandelsCertifieringUrl: string;
	footerBrandItems: Array<{
		name: string;
		url: string;
	}>;
	klarnaFaqLink: string;
	favicon: string;
	chatProvider: 'kundo' | 'snapEngage' | 'inhouseChat' | null;
	glnPattern: RegExp;
	storeName: string;
	eInvoicePaymentEnabled: boolean;
	paypalEnabled: boolean;
	elevenLabsAgent: string;
	elevenLabsStartHour?: number;
	elevenLabsEndHour?: number;
	inhouseChatAgentId?: string;
	inhouseChatApiUrl?: string;
	inhouseChatStartHour?: number;
	inhouseChatEndHour?: number;
	paypalClientId?: string;
	brandCollaborators: string[];
	gridBannerCategoryPermas: string[];
	gridBannerBrandSlugs: string[];
	logo: string;
}

export const ConfigContext = createContext<Config>(null as unknown as Config);

export function useConfig(): Config {
	return useContext(ConfigContext);
}
